import React, { Component } from "react";

import {
  Wrapper,
  ExternalImage,
  Copy,
  Icon
} from "app/NativeComponents/common";

import { determineMainOwnerInfo } from "app/NativeActions";

class MessageHeaderImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      owner_info: props.item
        ? props.item.property
          ? determineMainOwnerInfo(props.item.property)
          : null
        : null
    };
  }

  render() {
    if (this.props.item && this.props.item.property && this.state.owner_info) {
      const {
        owner_image,
        owner_name,
        owner_firstname,
        owner_lastname,
        owner_status_info
      } = this.state.owner_info;

      if (owner_image && owner_image !== "") {
        return (
          <Wrapper>
            <ExternalImage
              style={{
                width: 36,
                height: 36,
                marginRight: 10,
                borderRadius: 18
              }}
              image={owner_image}
            />
          </Wrapper>
        );
      }

      let image_initials = "";
      if (owner_name) {
        if (owner_firstname && owner_lastname) {
          if (owner_firstname.length > 0 && owner_lastname.length > 0) {
            image_initials = owner_firstname[0] + owner_lastname[0];
          } else if (owner_name.length > 1) {
            image_initials = owner_name[0] + owner_name[1];
          }
        } else if (owner_name.length > 1) {
          image_initials = owner_name[0] + owner_name[1];
        }
        image_initials = image_initials.toUpperCase();
      }

      if (image_initials.length > 0) {
        return (
          <Wrapper
            style={{
              width: 36,
              height: 36,
              marginRight: 10,
              borderRadius: 18,
              backgroundColor: this.props.colors.border_color,
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center"
            }}
          >
            <Copy style={{ width: 36, textAlign: "center" }}>
              {image_initials}
            </Copy>
          </Wrapper>
        );
      }
      if (owner_status_info) {
        if (owner_status_info.slug === "corporate_owner") {
          return (
            <Wrapper
              style={{
                width: 36,
                height: 36,
                marginRight: 10,

                borderRadius: 18,
                backgroundColor: this.props.colors.border_color,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon icon="business" size={18} />
            </Wrapper>
          );
        }
      }
    }

    return (
      <Wrapper
        style={{
          width: 36,
          height: 36,
          marginRight: 10,

          borderRadius: 18,
          backgroundColor: this.props.colors.gray_color,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Icon fa_icon="user" size={18} />
      </Wrapper>
    );
  }
}

export default MessageHeaderImage;
